import React, { FC, useEffect } from 'react';

function withNoScrollOnActive<T>(Component: FC<T>) {
  return function _(props: T & { isActive?: boolean }) {
    useEffect(() => {
      if (typeof window === 'undefined') {
        return;
      }

      if (props.isActive) {
        document.body.style.maxHeight = '100vh';
        document.body.style.maxWidth = '100vw';
        document.body.style.overflow = 'hidden';
      }

      return () => {
        document.body.style.maxHeight = 'unset';
        document.body.style.maxWidth = 'unset';
        document.body.style.overflow = 'unset';
      };
    }, [props.isActive]);

    return <Component {...(props as T & { isActive?: boolean })} />;
  };
}

export default withNoScrollOnActive;
